module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"general":"Général","complianceSurveyOnly":"Enquête de conformité seule","personInCharge":"Personne en charge du dossier :","project":"Adresse du projet","typeOfProperty":"Type de propriété :","numberPolice":"Numéro de police :","contact":"Contact","siret":"N°SIRET :","telephone":"Téléphone :","email":"E-mail :","city":"Ville :","undefined":"Non renseigné"}}')
  delete Component.options._Ctor
}
